import React, { useState } from 'react';
import { CheckCircle2, Zap, ShieldCheck, Lock, Clock } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const PAYMENT_URL = 'https://pagos.digipromarket.com/cart/56229348835654:1';
const PAYMENT_URL_UPSELL = 'https://pagos.digipromarket.com/cart/56229516345670:1';
export function ValueStack() {
  const [hasUpsell, setHasUpsell] = useState(false);
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(36000);
  const basePrice = 19.99;
  const upsellPrice = 5.0;
  const totalPrice = hasUpsell ? basePrice + upsellPrice : basePrice;
  const totalSavings = hasUpsell ? '94,93€' : '89,93€';
  return <section id="pricing" className="bg-warmWhite py-20 px-4" data-id="element-277">
      <div className="max-w-3xl mx-auto" data-id="element-278">
        <h2 className="text-3xl md:text-4xl font-heading text-center text-navy mb-12" data-id="element-279">
          "El Valor Real De Todo Lo Que Recibes Hoy"
        </h2>

        <div className="bg-white rounded-3xl shadow-xl border-2 border-navy/10 overflow-hidden" data-id="element-280">
          {/* Value Table */}
          <div className="p-6 md:p-8" data-id="element-281">
            <table className="w-full text-left border-collapse" data-id="element-282">
              <tbody data-id="element-283">
                <tr className="border-b border-gray-100" data-id="element-284">
                  <td className="py-4 text-gray-800 font-medium" data-id="element-285">
                    Tomo I: Cenas de Supervivencia 10 Min
                  </td>
                  <td className="py-4 text-right text-gray-600" data-id="element-286">19,99€</td>
                </tr>
                <tr className="border-b border-gray-100" data-id="element-287">
                  <td className="py-4 text-gray-800 font-medium" data-id="element-288">
                    Tomo II: El Mapa del Súper
                  </td>
                  <td className="py-4 text-right text-gray-600" data-id="element-289">14,99€</td>
                </tr>
                <tr className="border-b border-gray-100" data-id="element-290">
                  <td className="py-4 text-gray-800 font-medium" data-id="element-291">
                    Tomo III: Desayunos de 3 Minutos
                  </td>
                  <td className="py-4 text-right text-gray-600" data-id="element-292">14,99€</td>
                </tr>
                <tr className="border-b border-gray-100" data-id="element-293">
                  <td className="py-4 text-gray-800 font-medium" data-id="element-294">
                    Tomo IV: Repostería de Emergencia
                  </td>
                  <td className="py-4 text-right text-gray-600" data-id="element-295">14,99€</td>
                </tr>
                <tr className="border-b border-gray-100" data-id="element-296">
                  <td className="py-4 text-gray-800 font-medium" data-id="element-297">
                    Tomo V: Protocolo Reinicio 7 Días
                  </td>
                  <td className="py-4 text-right text-gray-600" data-id="element-298">14,99€</td>
                </tr>
                <tr className="border-b border-gray-100 bg-cream/50" data-id="element-299">
                  <td className="py-4 text-gray-800 font-medium" data-id="element-300">
                    🎁 Bono #1: Airfryer Perfecta en 7 Min
                  </td>
                  <td className="py-4 text-right text-gray-600" data-id="element-301">9,99€</td>
                </tr>
                <tr className="border-b border-gray-100 bg-cream/50" data-id="element-302">
                  <td className="py-4 text-gray-800 font-medium" data-id="element-303">
                    🎁 Bono #2: Menús "No Pienso" 30 Días
                  </td>
                  <td className="py-4 text-right text-gray-600" data-id="element-304">9,99€</td>
                </tr>
                <tr className="border-b border-gray-200 bg-cream/50" data-id="element-305">
                  <td className="py-4 text-gray-800 font-medium" data-id="element-306">
                    🎁 Bono #3: Tracker Resultados Visibles
                  </td>
                  <td className="py-4 text-right text-gray-600" data-id="element-307">9,99€</td>
                </tr>
                <tr data-id="element-308">
                  <td className="py-6 text-xl font-bold text-navy" data-id="element-309">
                    VALOR TOTAL
                  </td>
                  <td className="py-6 text-xl text-right font-bold text-gray-400 line-through" data-id="element-310">
                    109,92€
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Upsell Bump — integrated */}
          <div className="border-t-2 border-dashed border-gold/40 mx-6 md:mx-8" data-id="element-311" />
          <div className="p-6 md:p-8" data-id="element-312">
            <div onClick={() => setHasUpsell(!hasUpsell)} className={`
                cursor-pointer rounded-2xl border-3 p-5 transition-all duration-300
                ${hasUpsell ? 'border-gold bg-cream shadow-md' : 'border-navy/15 bg-gray-50 hover:bg-cream/50'}
              `} data-id="element-313">
              <div className="flex items-start gap-4" data-id="element-314">
                <div className={`
                    w-7 h-7 rounded-lg border-2 flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors
                    ${hasUpsell ? 'bg-teal border-teal text-white' : 'border-gray-400 bg-white'}
                  `} data-id="element-315">
                  {hasUpsell && <CheckCircle2 className="w-5 h-5" data-id="element-316" />}
                </div>

                <div className="flex-1" data-id="element-317">
                  <div className="flex items-center gap-2 mb-2" data-id="element-318">
                    <Zap className="w-5 h-5 text-gold" data-id="element-319" />
                    <span className="font-bold text-navy text-lg" data-id="element-320">
                      ⚡ AÑADIR: Kit Acelerador "Vientre Plano" (+5€)
                    </span>
                  </div>

                  <ul className="space-y-1.5 mb-3" data-id="element-321">
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-322">
                      <CheckCircle2 className="w-4 h-4 text-teal flex-shrink-0 mt-0.5" data-id="element-323" />
                      <span data-id="element-324">
                        Los 7 Saboteadores Saludables que frenan tu abdomen
                      </span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-325">
                      <CheckCircle2 className="w-4 h-4 text-teal flex-shrink-0 mt-0.5" data-id="element-326" />
                      <span data-id="element-327">Protocolo 21 Días "Vientre Plano" en 3 fases</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-328">
                      <CheckCircle2 className="w-4 h-4 text-teal flex-shrink-0 mt-0.5" data-id="element-329" />
                      <span data-id="element-330">
                        7 Bebidas Metabólicas Nocturnas + Auditoría
                        anti-estancamiento
                      </span>
                    </li>
                  </ul>

                  <p className="text-xs italic text-gray-500" data-id="element-331">
                    "Los pacientes que añaden este protocolo pierden entre 3 y
                    5cm más de cintura." — Dra. Elena Martínez Solís
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Payment CTA Section */}
          <div className="bg-navy p-6 md:p-8 border-t-4 border-gold" data-id="element-332">
            <div className="flex flex-col items-center gap-6" data-id="element-333">
              {/* Price Display */}
              <div className="text-center" data-id="element-334">
                <span className="block text-white/70 text-sm font-medium mb-1" data-id="element-335">
                  TÚ PAGAS HOY
                </span>
                <div className="flex items-center justify-center gap-3" data-id="element-336">
                  <span className="text-5xl md:text-6xl font-heading font-bold text-gold drop-shadow-lg" data-id="element-337">
                    {hasUpsell ? '24,99€' : '19,99€'}
                  </span>
                </div>
                <span className="inline-block bg-teal text-white text-sm font-bold px-4 py-1.5 rounded-full mt-3" data-id="element-338">
                  Ahorras {totalSavings} hoy
                </span>
              </div>

              {/* Countdown */}
              <div className="flex items-center gap-2 text-white/80 text-sm font-medium" data-id="element-339">
                <Clock className="w-4 h-4 text-gold animate-pulse" data-id="element-340" />
                <span data-id="element-341">
                  Oferta expira en: {hours}:{minutes}:{seconds}
                </span>
              </div>

              {/* Payment Button */}
              <a href={hasUpsell ? PAYMENT_URL_UPSELL : PAYMENT_URL} className="w-full max-w-lg block" data-id="element-342">
                <div className="w-full bg-gold hover:bg-goldDark text-white font-bold text-center px-8 py-5 rounded-2xl shadow-2xl transition-all duration-300 animate-cta-pulse border-4 border-gold/30 hover:border-goldDark/30" data-id="element-343">
                  <span className="text-xl md:text-2xl block mb-1 drop-shadow-sm" data-id="element-344">
                    🔥{' '}
                    {hasUpsell ? 'QUIERO EL PACK + KIT POR 24,99€' : 'QUIERO EL PACK COMPLETO POR 19,99€'}
                  </span>
                  <span className="text-sm font-medium opacity-90" data-id="element-345">
                    (Acceso inmediato · Garantía 7 días · Pago seguro)
                  </span>
                </div>
              </a>

              {/* Trust badges */}
              <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-white/50 font-medium" data-id="element-346">
                <div className="flex items-center gap-1.5" data-id="element-347">
                  <Lock className="w-3.5 h-3.5" data-id="element-348" />
                  <span data-id="element-349">SSL encriptado</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-350">
                  <ShieldCheck className="w-3.5 h-3.5" data-id="element-351" />
                  <span data-id="element-352">Garantía 7 días</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-353">
                  <Clock className="w-3.5 h-3.5" data-id="element-354" />
                  <span data-id="element-355">Acceso inmediato</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}